import { Controller } from "react-hook-form";
import moment, { Moment } from "moment";
import { int } from "../../models/base.model";
import { FormInputProps } from "../../models/form.model";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export default function FormDate(
  props: FormInputProps & {
    type: "date" | "datetime" | "time";
    minDate?: Moment;
    minDateTime?: Moment;
    maxDateTime?: Moment;
    minutesStep?: int;
    disableFuture?: boolean;
    dataTestId?: string;
    defaultValue?: Moment;
    onAccept?: (value: Moment | null) => void;
  }
) {
  const {
    name,
    control,
    type,
    label,
    helperText,
    rules,
    required,
    setError,
    disableFuture,
    dataTestId,
    defaultValue = moment(),
    onChange: onChangeProp,
    onAccept
  } = props;

  const setErrorMsg = (message: string) => {
    setError(name, { type: "manual", message });
  };
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({
          field: { onChange, value = null },
          fieldState: { error },
          formState,
        }) => {
          switch (type) {
            case "date":
              return (
                <DatePicker
                  label={label}
                  value={value}
                  format="YYYY-MM-DD"
                  className="width-100p"
                  onChange={(newValue: Moment | null) => {
                    onChange(newValue);
                    onChangeProp?.(newValue);
                  }}
                  onAccept={onAccept}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: required,
                      helperText: error ? error.message : helperText || null,
                      inputProps: {
                        "data-testid": dataTestId || name,
                      },
                    },
                    openPickerButton: {
                      id: 'date-openPickerButton',
                    }
                  }}
                  disableFuture={disableFuture}
                />
              );
            case "datetime":
              return (
                <DateTimePicker
                  label={label}
                  value={value}
                  className="width-100p"
                  onChange={(newValue: Moment | null) => {
                    onChange(newValue);
                    onChangeProp?.(newValue);
                  }}
                  format="YYYY-MM-DD HH:mm"
                  minDate={props.minDate}
                  onAccept={onAccept}
                  minDateTime={props.minDateTime}
                  maxDateTime={props.maxDateTime}
                  minutesStep={props.minutesStep}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: required,
                      helperText: error ? error.message : helperText || null,
                      inputProps: {
                        "data-testid": dataTestId || name,
                      },
                    },
                    openPickerButton: {
                      id: 'datetime-openPickerButton',
                    }
                  }}
                  disableFuture={disableFuture}
                />
              );
            case "time":
              return (
                <TimePicker
                  label={label}
                  value={value}
                  className="width-100p"
                  onChange={(newValue: Moment | null) => {
                    onChange(newValue);
                    onChangeProp?.(newValue);
                  }}
                  slotProps={{
                    textField: {
                      error: !!error,
                      required: required,
                      helperText: error ? error.message : helperText || null,
                      inputProps: {
                        "data-testid": dataTestId || name,
                      },
                    },
                    openPickerButton: {
                      id: 'time-openPickerButton',
                    }
                  }}
                  disableFuture={disableFuture}
                />
              );
            default:
              return <div></div>;
          }
        }}
      />
    </LocalizationProvider>
  );
}
